/**
 * The number locale money is shown in (docs/tax-addition/02-build-contract.md §9).
 *
 * The header Country switcher (`country-context.tsx`) sets it: a single country
 * shows its own grouping (en-IN lakh / crore, es-CO, ...), ALL keeps the
 * app-wide default. A module-level value rather than React context so the plain
 * formatters (`formatMoney`, `formatCompactAmount`) can read it; the provider
 * remounts the page when it changes, so every figure re-renders.
 *
 * No React, no path aliases: Node's test runner (`npm run test:unit`) loads it.
 */

export const DEFAULT_LOCALE = 'en-US'

let current = DEFAULT_LOCALE

function supported(locale: string): boolean {
  try {
    return Intl.NumberFormat.supportedLocalesOf([locale]).length > 0
  } catch {
    return false
  }
}

/** The locale to format numbers in now. */
export function displayLocale(): string {
  return current
}

/** Set the number locale; an empty or unsupported value restores the default. */
export function setDisplayLocale(locale: string | null | undefined): void {
  const next = (locale ?? '').trim()
  current = next && supported(next) ? next : DEFAULT_LOCALE
}

/**
 * The locale for a country in the switcher: the tax pack's own locale when it
 * has one, otherwise English with that region's conventions (`en-MY`, `en-JP`).
 */
export function localeForCountry(code: string | null | undefined, packLocale?: string | null): string {
  if (packLocale && supported(packLocale)) return packLocale
  const region = (code ?? '').trim().toUpperCase()
  if (/^[A-Z]{2}$/.test(region) && supported(`en-${region}`)) return `en-${region}`
  return DEFAULT_LOCALE
}
